import React, { Suspense, lazy } from 'react';
/**
 * This is a route-based lazy-loader function. It returns a component which lazy-loads a component
 * as a separate JavaScript bundle when rendered. It will show the "loading" component using React.Suspense
 * while waiting for the bundle to load.
 */
export default function loadOnRender({ loader, loading: Fallback, }) {
    const LazyLoadedComponent = lazy(loader);
    const fallback = Fallback ? React.createElement(Fallback, null) : null;
    return (props) => (React.createElement(Suspense, { fallback: fallback },
        React.createElement(LazyLoadedComponent, { ...props })));
}
//# sourceMappingURL=loadOnRender.js.map